// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import store from './store/store';
require("expose-loader?$jQuery!jquery");


window.store = store;

window.historyurl = "";

window.onhashchange = function(e) {
    e.preventDefault();
    if( historyurl =="#redirect") {
        $jQuery( '.product-info-main' ).addClass( 'label_editor_landing' );
        $jQuery( '.product-info-main' ).removeClass( 'label_editor' );
        $jQuery( 'body' ).addClass( 'label_editor_landing' );
        $jQuery( '#multipacksPrintq' ).show();
    }else{
        if( window.location.hash == "#redirect" ) {
            $jQuery( '.product-info-main' ).removeClass( 'label_editor_landing' );
            $jQuery( '.product-info-main' ).addClass( 'label_editor' );
            $jQuery( 'body' ).removeClass( 'label_editor_landing' );
            $jQuery( '#multipacksPrintq' ).hide();
        }
    }
    window.historyurl = window.location.hash;
}
setInterval( function() {
   if($jQuery( 'body' ).hasClass( 'label_editor_landing' ))
    if($jQuery('.fotorama__stage').height() ==0){
        var resizeEvent = window.document.createEvent( 'UIEvents' );
        resizeEvent.initUIEvent( 'resize', true, false, window, 0 );
        window.dispatchEvent( resizeEvent );
    jQuery( window ).resize();
} }, 400 );
$jQuery( document ).ready( function() {
    window.historyurl = window.location.hash;
    /* eslint-disable no-new */
        new Vue( {
            el     : '#app',
            store,
            render : h => h( App )
        } );
          $jQuery('.labelsContainer').on('click','.cmpt',function(){
                var pageContainer=$jQuery(this).closest('.page-container');
                if(pageContainer.length){
                    pageContainer.find('.startDesign').hide();
                }
          });
          $jQuery('.design-label-btn').on('click',function(){
              window.location.hash = "redirect";
              var els = document.querySelectorAll( ".previewContainer.product-images" );
              if ( els.length ) {
                  for ( var i = 0; i < els.length; i++ ) {
                      var _el = els[i];
                      var bounding = _el.parentElement.parentElement.getBoundingClientRect()
                      var bounding2 = _el.parentElement.getBoundingClientRect()
                      if ( bounding.top < 0 ) {
                          var top = -1 * parseFloat( bounding.top );
                          if ( top > bounding.height - _el.offsetHeight ) {
                              top = bounding.height - _el.offsetHeight;
                          }
                          _el.style.top = top + "px";
                      }
                      else {
                          _el.style.top = "0px";
                      }
                  }
              }
              var print_setup = document.querySelector( ".print-setup.print_setup" );
              var labelsContainer = document.querySelector( ".labelsContainer" );
              print_setup.style.height = labelsContainer.offsetHeight + "px";
          })


        function sticky ( _el ) {


            document.addEventListener( "scroll", function() {

                var bounding = _el.parentElement.parentElement.getBoundingClientRect()
                var bounding2 = _el.parentElement.getBoundingClientRect()
                if ( bounding.top < 0 ) {
                    var top = -1 * parseFloat( bounding.top );
                    if ( top > bounding.height - _el.offsetHeight ) {
                        top = bounding.height - _el.offsetHeight;
                    }
                    _el.style.top = top+"px";
                }
                else {
                    _el.style.top = "0px";
                }
            } );
        }


        var els = document.querySelectorAll( ".previewContainer.product-images" );
        if(els.length){
            for(var i =0 ;i<els.length;i++){
                var el = els[i];
                sticky( el );
            }

        }

    } )

    ! (function( $ ) {
        var PLB = $.printqLabelEditor = {};
        $.extend( PLB, {
            defaults     : {},
            passChanges  : function( code, labelId ,parent,product_part) {
                var option = $jQuery('#select_PP_'+product_part+'_'+parent).find( "[name='" + code + "']" );
                var parent = $jQuery(option).parent();
                parent.val( code)
                parent.find('option').attr('selected',false);
                if ( option.length ) {
                    option.attr( 'selected', true );
                    PrintOptions.changeData( labelId );
                }

            },

            passChangesStock : function( code, parent, product_part ) {
                var option = $jQuery( '#select_PP_' + product_part + '_' + parent ).find( "[name='" + code + "']" );
                var parent = $jQuery( option ).parent();
                parent.val( code )
                parent.find( 'option' ).attr( 'selected', false );
                if ( option.length ) {
                    option.attr( 'selected', true );
                    PrintOptions.changeData();
                }
            },

            changesReady : function( data, labelId ) {
                store.dispatch( 'setLabelReady', {data : data, labelId : labelId} );
                if ( ! $.isEmptyObject( data.pp_opt ) ) {
                    $jQuery.each( data.pp_opt, function( key, value ) {
                        if ( key.indexOf( "PP_" ) >= 0 ) {
                            $jQuery.each( value, function( k, val ) {
                                const x= $jQuery( ".page_option" + val[0] + "_" + key.replace("PP_","") );
                                x.show();
                                if(!x.hasClass('active')){
                                    x.addClass( 'shouldNotPassChanges' );
                                    x.trigger('click')
                                }
                            } );
                        }
                    } );

                }
            }

        } );
    })( window.$jQuery )
!(function ($) {
    var PFT = $.printqFitText = {}
    $.extend(PFT, {
        defaults: {
            maxIterations: 200,
            multiplier: 0.1,
            textArea: "#textArea",
            minFontSize: 15,
            cbGetter : "#cbGetter"
        },
        _O: function (o) {
            var defaults = $.extend(true, {}, PFT.defaults);
            return $.extend(true, defaults, o);
        },
        adjustText: function (block, label) {
            var o = PFT._O({});
            label.canWrite = 0;
            var procent = (block['page_resize_percentageW'] / 100).toFixed(4);
            var e = {};
            e.iterations = 0;

            var width = parseFloat(block['width']);
            if (parseInt(label.use_master_block)/* && !block['copy'].length*/) {
                if (typeof (label.lines) != "undefined") {
                    label.lines.forEach(function (element) {
                        if (parseInt(element.masterBlock)) {
                            if (!parseInt(label.use_icon) && parseInt(element.master_type)) {
                                width = parseFloat(element.width);
                            }
                        }
                    });
                }
            }


            var procentWidth = parseFloat(block['page_resize_percentageW'] / 100);
            var procentHeight = parseFloat(block['page_resize_percentageH'] / 100);
            var oldS = parseFloat(block['font_size_default']);
            var min = label.min_fontsize;
            if (typeof (fontsConfig[label.code]) != "undefined") {
                if (typeof (fontsConfig[label.code][block.font]) != "undefined") {
                    var max = parseFloat(fontsConfig[label.code][block.font]['max'])
                    if (oldS > max)
                        oldS = max;
                    min = parseFloat(fontsConfig[label.code][block.font]['min']);
                }
            }
            var localValue = oldS,
                htmlValue = localValue + 'pt',
                jTextArea = $(o.textArea),
                textArea = jTextArea.get(0);
            if (block['text'].length)
                var textareaVAlue = block['text'];
            else
                var textareaVAlue = block['placeholder'];
            var lineHeightParams = PFT.getLineHeight(oldS, block);
            block['line-height'] = lineHeightParams['lineheight_editor'] / 0.75;
            block['lineheightpdflib'] = lineHeightParams['lineheightpdflib'];
            jTextArea.html(textareaVAlue);
            if (oldS < min) {
                oldS = min;
            }
            jTextArea.css({
                width: 'auto',
                height: 'auto',
                'font-size': oldS + "pt",
                'font-weight': block['font-weight'],
                'font-family': "'" + block['font'] + "'",
                'letter-spacing': block['letter-spacing'],
                'line-height': lineHeightParams['lineheight_editor'] + "px",
                'word-spacing': block['word-spacing'],
                'white-space': 'pre',
                margin: 0,
                padding: 0,
                border: 'none'
            });
            block['fontsize'] = oldS;

            PFT.setFontForge(block);

            var pdfLibBlockHeightCalculated = PFT.getCalculatedBlockHeight(block);
            var pblockHeight = parseFloat(block['pdf_height'] * block['height'] / block['page_height']).toFixed(2);
            var lines = jTextArea.height() / lineHeightParams['lineheight_editor'];
            var pdflibHeight = pdfLibBlockHeightCalculated + (lines - 1) * lineHeightParams['lineheightpdflib'];
            while (
                (
                    (width < (textArea.scrollWidth - 1)) ||
                    /*  (block['height'] < textArea.scrollHeight * procentWidth) ||*/
                    (width < (textArea.scrollWidth * procentWidth - (parseFloat(block['charspacing']) / 0.75) * procentWidth - 1)) /*||
                                (pdflibHeight > pblockHeight)*/
                ) &&
                (o.maxIterations > e.iterations) &&
                oldS > 0
                ) {
                oldS = oldS - parseFloat(block['multiplier']);
                if (oldS < min) {
                    oldS = min;
                    textareaVAlue = textareaVAlue.slice(0, -1);
                }
                localValue = oldS,
                    htmlValue = oldS + 'pt';
                var lineHeightParams = PFT.getLineHeight(oldS, block);

                block['line-height'] = lineHeightParams['lineheight_editor'] / 0.75;

                jTextArea.html('');
                jTextArea.css('overflow', 'hidden');

                jTextArea.css({
                    width: 'auto',
                    height: 'auto',
                    'font-size': oldS + "pt",
                    'font-weight': block['font-weight'],
                    'font-family': "'" + block['font'] + "'",
                    'letter-spacing': block['letter-spacing'],
                    'line-height': lineHeightParams['lineheight_editor'] + "px",
                    'word-spacing': block['word-spacing'],
                    'white-space': 'pre',
                    resize: 'none',
                    margin: 0,
                    padding: 0,
                    border: 'none'
                });

                jTextArea.html(textareaVAlue);
                jTextArea.css('overflow', 'auto');

                block['fontsize'] = oldS;
                var pdfLibBlockHeightCalculated = PFT.getCalculatedBlockHeight(block);
                var lines = jTextArea.height() / lineHeightParams['lineheight_editor'];
                var pdflibHeight = pdfLibBlockHeightCalculated + (lines - 1) * lineHeightParams['lineheightpdflib'];
                e.iterations++;
            }
            block['lineheightpdflib'] = lineHeightParams['lineheightpdflib'];
            if (e.iterations > 0) {
                if (parseFloat(block['multiplier']) == 0.1)
                    block['fontsize'] = oldS + parseFloat(block['multiplier']);
                else
                    block['fontsize'] = oldS;
                oldText = block['text']
                block['text'] = textareaVAlue;

            } else {
                block['fontsize'] = oldS;
                var oldText = block['text'];
                block['text'] = textareaVAlue;


            }

            if (oldText != textareaVAlue) {
                if (typeof (Event) === 'function') {
                    event = new Event('updateLine');
                } else {
                    event = document.createEvent('Event');
                    event.initEvent('updateLine', true, true);

                }
                window.dispatchEvent(event)
            }
            PFT.setFontForge(block);
            //     label.textIsCut = 0;

            label.canWrite = 1;

        },
        getLineHeight: function (fontSize, block) {
            var lineheightp = parseFloat(block['lineheightp']);
            var lineheightn = parseFloat(block['lineheightn']);
            var lh = 100;
            if (typeof (lineheightp) != "undefined" && block['lineheightp']) {
                lh = lineheightp;
            } else {
                if (typeof (lineheightn) != "undefined" && block['lineheightn'])
                    lh = lineheightn;
            }
            var d = (fontSize / 0.75 * (lh / 100));
            if ((d % 1) > 0.5) {
                if (d == 0) {
                    var lh1 = 0;
                } else {
                    var lh1 = ((fontSize * Math.ceil(d)) / d) * (lh / 100);
                }
                var lineHeightEditor = Math.ceil(d);
                var lineHeightPdf = lh1.toFixed(2);
            } else {
                if (d == 0) {
                    var lh1 = 0;
                } else {
                    var lh1 = ((fontSize * Math.floor(d)) / d) * (lh / 100);
                }
                var lineHeightEditor = Math.floor(d);
                var lineHeightPdf = lh1.toFixed(2);

            }

            return {
                lineheight_editor: lineHeightEditor,
                lineheightpdflib: lineHeightPdf,
            }
        },
        setFontForge: function (block) {
            var top = 0;
            var editableArea = $("#" + block.uniqueId);
            var lineheightp = parseFloat(block['lineheightp']);
            var lineheightn = parseFloat(block['lineheightn']);
            var valignment = block['valignment'];
            var fontSize = parseFloat(block['fontsize']);
            var font = block['font'];
            var lineHeight = 1;
            if (typeof (lineheightp) != "undefined" && block['lineheightp']) {
                lineHeight = lineheightp / 100;
            } else {
                if (typeof (lineheightn) != "undefined" && block['lineheightn'])
                    lineHeight = lineheightn / 100;
            }
            var diff = (editableArea.get(0).getBoundingClientRect().height - editableArea.parent().parent().get(0).getBoundingClientRect().height) * 0.75 / parseFloat((block['page_resize_percentageH'] / 100));
            //diff =0;
            if (typeof (fontConfigForge[font]) != "undefined") {
                var configFont = fontConfigForge[font];
                var tpa = ((configFont.ir / 2) * fontSize) / 100;
                var tpa3 = (fontSize * lineHeight - fontSize) / 2;
                switch (valignment) {
                    case 'top':
                        var maxAscent = Math.max(parseFloat(configFont.hhascent), parseFloat(configFont.winascent));
                        var tpa1 = ((maxAscent - parseFloat(configFont.typoascent)) / parseFloat(configFont.emsize) * 100) * fontSize / 100;
                        top = tpa - tpa1 - tpa3;
                        break;
                    case 'middle':
                        var maxAscent = Math.max(parseFloat(configFont.hhascent), parseFloat(configFont.winascent));
                        var tpaTop = ((maxAscent - parseFloat(configFont.typoascent)) / parseFloat(configFont.emsize) * 100) * fontSize / 100;
                        var maxDescent = Math.max(parseFloat(configFont.hhdescent), parseFloat(configFont.windescent));
                        var tpaBottom = ((maxDescent) / parseFloat(configFont.emsize) * 100) * fontSize / 100
                        var top1 = tpa - tpaTop - tpa3;
                        var top2 = tpa - tpaBottom - tpa3;

                        top = (top1 - top2) / 2;
                        if (diff > 0)
                            top -= (diff / 2);
                        // diff/=2;
                        break;
                    case 'bottom':
                        var maxDescent = Math.max(parseFloat(configFont.hhdescent), parseFloat(configFont.windescent));
                        var tpa1 = ((maxDescent) / parseFloat(configFont.emsize) * 100) * fontSize / 100
                        top = -1 * (tpa - tpa1 - tpa3);
                        if (diff > 0)
                            top -= (diff);
                        break;
                    default:
                        break;
                }
            }
            block['topAdjust'] = top;
        },
        getCalculatedBlockHeight: function (block) {
            var blockHeightPdflib = 0;
            var fontSize = parseFloat(block['fontsize']);
            var font = block['font'];
            if (typeof (fontConfigForge[font]) != "undefined") {
                var configFont = fontConfigForge[font];
                blockHeightPdflib = (parseFloat(configFont.typoascent) / parseFloat(configFont.emsize) * 100) * fontSize / 100;
            }
            return blockHeightPdflib;
        },
        getFontForge: function(data){
            var o = PFT._O({});
            var result = {
                top: 0,
                bottom: 0
            };
            var font = data['font'];
            var fontSize = data['fontSize'];

            if (typeof (fontConfigForge[font]) != "undefined") {
                var fontSize = fontSize / 0.75;
                var lineHeight = fontSize / 0.75;
                var configFont = fontConfigForge[font];
                var CB = configFont['cb'];
                var CB_Ascender = configFont['winascent'] / configFont['emsize'] * fontSize;
                var CB_Descender = configFont['windescent'] / configFont['emsize'] * fontSize;
                var Ascender = configFont['typoascent'] / configFont['emsize'] * fontSize;
                var Descender = configFont['typodescent'] / configFont['emsize'] * fontSize;
                var cbGetter = $(o.cbGetter);
                cbGetter.css('font-family', '"' + font + '"');
                var realCB = cbGetter.height() * 0.75 / 100;
                var guessedCB = (configFont['typoascent'] - configFont['typodescent']) / configFont['emsize'];
                if (
                    (realCB >= 0.975 && realCB <= 1.005) ||
                    (guessedCB >= realCB - 0.05 && guessedCB <= realCB + 0.05)
                ) {
                    CB = realCB;
                    CB_Ascender = Ascender;
                    CB_Descender = Descender;
                }
                if (window.osX) {
                    var CB = configFont['cbH'];
                    var CB_Ascender = configFont['hhascent'] / configFont['emsize'] * fontSize;
                    var CB_Descender = configFont['hhdescent'] / configFont['emsize'] * fontSize;
                }

                result['top'] = ((((CB * fontSize) - lineHeight) / 2) - (CB_Ascender - Ascender));
                result['bottom'] = ((Math.abs(CB_Descender) - Math.abs(Descender)) - (((CB * fontSize) - lineHeight) / 2));
            }
            return result;
        }
    });

})(window.$jQuery);




// WEBPACK FOOTER //
// ./src/main.js